import React from "react";
import Template from "./template";
import homePageJson from "../../content/pages/home/index.json";

function Spotlight() {
  const { marketplaceSpotLiteSection, memberSpotLiteSection } = homePageJson;
  const { services } = marketplaceSpotLiteSection;
  const { companies } = memberSpotLiteSection;

  const svcRndIx = Math.floor(Math.random() * services.length);
  const cmpRndIx = Math.floor(Math.random() * companies.length);

  const data = {
    title: marketplaceSpotLiteSection.title,
    text: marketplaceSpotLiteSection.text,
    memberSectionTitle: memberSpotLiteSection.title,
    currentService: services[svcRndIx].companyService,
    currentCompany: companies[cmpRndIx]
  };

  return <Template data={data} />;
}

export default Spotlight;
